// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-coMhXY","logo":"logo-vxaJuF"};